import FlexBox from '@sharedComponents/FlexBox';
import Typography from '@sharedComponents/Typography';
import { Trans, withTranslation } from 'react-i18next';

const FormGroup = withTranslation()(({ t, label = '', children, errorMsg = '', optionnal = false, isDisabled = false }) => {
    return (
        <FlexBox flexDirection="column" gap="xs">
            {label && (
                <Typography color={isDisabled ? 'disabled' : errorMsg ? 'error-primary' : 'neutral-primary'} fontWeight="regular">
                    <Trans
                        i18nKey={!optionnal ? label : label + ` <0>${t('Optionnal')}<0>`}
                        components={[<span key="optionnal" style={{ color: 'var(--text-color-neutral-tertiary)' }} />]}
                    />
                </Typography>
            )}
            {children}
            {errorMsg && (
                <Typography color={'error-primary'} fontWeight="regular" fontSize="xs">
                    {errorMsg}
                </Typography>
            )}
        </FlexBox>
    );
});

export default FormGroup;
